<template>
    <Dashboard></Dashboard>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const Dashboard = defineAsyncComponent(() =>
    import("../../components/DPAM_PunchSystem/Dashboard.vue")
);

export default {
    name: "DPAM_PUNCH_DASHBOARD", //The name you are in should not equal the name of the component you are importing.
    components: { Dashboard, AuthLayout },
};
</script>
